/**
 * Converts a hex color code to an RGBA color string.
 *
 * @param {string} hex - The hex color code (e.g., "#ff0000" or "ff0000").
 * @param {number} alpha - The alpha (opacity) value, between 0 (transparent) and 1 (opaque).
 * @returns {string} The RGBA color string (e.g., "rgba(255, 0, 0, 0.5)").
 */
export const hexToRgba = (hex, alpha) => {
  const bigint = parseInt(hex.replace("#", ""), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
